import React, { useContext, useEffect, useRef, useState } from "react";
import {
  CalendarIcon,
  HomeIcon,
  UsersIcon,
  Cog8ToothIcon,
  UserGroupIcon,
  CurrencyRupeeIcon,
  ListBulletIcon,
  DocumentTextIcon,
  KeyIcon,
  RectangleGroupIcon,
  BeakerIcon,
  BuildingStorefrontIcon,
  BuildingOffice2Icon,
  UserIcon,
  ViewColumnsIcon,
  QueueListIcon
} from "@heroicons/react/24/outline";

import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { Select } from "antd";
import { updateUserData } from "../apis/user";
import { LanguageContext } from "../providers/LanguageProvider";

export interface navItem {
  name: string;
  icon: any;
  route: string;
  isCurrent: boolean;
  children: Array<navItem>;
  showChildren: boolean;
}

function classNames(...classes: Array<string>) {
  return classes.filter(Boolean).join(" ");
}

const Dashboard: React.FC<{}> = () => {
  const { translate: t } = useContext(LanguageContext);
  const { updateLanguage } = useContext(LanguageContext);
  const user = window.localStorage.getItem("user");
  const navigate = useNavigate();
  const location = useLocation();
  const [loggedInUser, setLoggedInUser] = useState({
    id: "",
    preferredLanguage: "en",
    firstName: "",
    lastName: "",
    roles: [],
  });
  const [isMobileMenusVisible, setMobileMenuVisible] = useState(false);
  const [isVisibleUserOptions, setIsVisibleUserOptions] =
    useState<boolean>(false);
  const [developerSettings, setDeveloperSettings] = useState<navItem>({
    name: "Developer Settings",
    route: "#",
    icon: Cog8ToothIcon,
    isCurrent: false,
    children: [
      {
        name: "visit_types_list",
        icon: HomeIcon,
        route: "/visit-types-list",
        isCurrent: false,
        children: [],
        showChildren: false,
      },
    ],
    showChildren: false,
  });
  const baseNavigation = [
    {
      name: "patient",
      route: "/patients",
      icon: UserGroupIcon,
      isCurrent: false,
      children: [

      ],
      showChildren: false,
    },

    {
      name: "episodes",
      route: "/episodes",
      icon: QueueListIcon,

      isCurrent: false,
      children: [],
    },
    {
      name: "OPD Visits",
      route: "/opd-visits",
      icon: UserIcon,
      isCurrent: false,
      children: [],
      showChildren: false,
    },
    {
      name: "IPD",
      route: "/ipd-visits",
      icon: BuildingOffice2Icon,
      isCurrent: false,
      children: [],
      showChildren: false,


      // {
      //     name: "IPD Visits",
      //     route: "/ipd-visits",
      //     icon: HomeIcon,
      //     isCurrent: false,
      //     children: [],
      //     showChildren: false,
      //   },
      //   {
      //     name: "room_types",
      //     route: "/room-types",
      //     icon: HomeIcon,
      //     isCurrent: false,
      //     children: [],
      //     showChildren: false,
      //   },
      //   {
      //     name: "rooms",
      //     route: "/rooms",
      //     icon: HomeIcon,
      //     isCurrent: false,
      //     children: [],
      //     showChildren: false,
      //   },
      //   {
      //     name: "bed_layout",
      //     route: "/bed-layout",
      //     icon: ViewColumnsIcon,
      //     isCurrent: false,
      //     children: [],
      //     showChildren: false,
      //   },
      //   {
      //     name: "bed_layout_3d",
      //     route: "/bed-layout-3d",
      //     icon: ViewColumnsIcon,
      //     isCurrent: false,
      //     children: [],
      //     showChildren: false,
      //   },
      // ],
    },
    {
      name: "bed_layout",
      route: "/bed-layout",
      icon: ViewColumnsIcon,
      isCurrent: false,
      children: [],
      showChildren: false,
    },

    {
      name: "calendar",
      route: "/calendar",
      icon: CalendarIcon,
      isCurrent: false,
      children: [],
      showChildren: false
    },
    {
      name: "Pharmacy",
      route: "#",
      icon: BeakerIcon,
      isCurrent: false,
      children: [
        {
          name: "pharmacy_sales",
          route: "/pharmacy/pos/list",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "pos",
          route: "/pharmacy/pos",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "pharmacy_items",
          route: "/items-list",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "product_bundles",
          route: "/product-bundles",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "suppliers",
          route: "/supplier-list",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "purchase_orders",
          route: "/purchase-orders",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "grns",
          route: "/GRNs",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
      ],
      showChildren: false,
    },
    {
      name: "Lab Orders",
      route: "/lab-order-list",
      icon: BuildingStorefrontIcon,
      isCurrent: false,
      children: [
        // {
        //   name: "orders",
        //   route: "/lab-order-list",
        //   icon: HomeIcon,
        //   isCurrent: false,
        //   children: [],
        //   showChildren: false,
        // },
        // {
        //   name: "lab_tests",
        //   route: "/test-list",
        //   icon: HomeIcon,
        //   isCurrent: false,
        //   children: [],
        //   showChildren: false,
        // },
        // {
        //   name: "lab_tests_categories",
        //   route: "/lab-categories",
        //   icon: HomeIcon,
        //   isCurrent: false,
        //   children: [],
        //   showChildren: false,
        // },
      ],
      showChildren: false,
    },
    {
      name: "duty_roster",
      route: "/duty-roster",
      icon: HomeIcon,
      isCurrent: false,
      children: [],
      showChildren: false,
    },
    {
      name: "attendance",
      route: "/attendance",
      icon: HomeIcon,
      isCurrent: false,
      children: [],
      showChildren: false,
    },

    {
      name: "finance",
      route: "#",
      icon: CurrencyRupeeIcon,
      isCurrent: false,
      children: [
        {
          name: "billing",
          route: "/billing",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "doctor_payouts",
          route: "/doctor-payouts",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "expenses",
          route: "/expenses",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
      ],
      showChildren: false,
    },
    {
      name: "reports",
      route: "#",
      icon: DocumentTextIcon,
      isCurrent: false,
      children: [
        {
          name: "dashboard",
          route: "/dashboard",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "logs",
          route: "/logs",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
      ],
      showChildren: false,
    },
    {
      name: "settings",
      route: "#",
      icon: Cog8ToothIcon,
      isCurrent: false,
      children: [
        {
          name: "organisation",
          route: "/settings",
          icon: HomeIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "masters",
          route: "/masters",
          icon: ListBulletIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "users",
          route: "/users",
          icon: UsersIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "roles_and_permissions",
          route: "/roles-and-permissions",
          icon: KeyIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
        {
          name: "layout_design",
          route: "/layout-design",
          icon: RectangleGroupIcon,
          isCurrent: false,
          children: [],
          showChildren: false,
        },
      ],
      showChildren: false,
    },
  ];

  const [navigation, setNavigation] = useState<any>(baseNavigation);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (user) {
      setLoggedInUser(JSON.parse(user));
    }
  }, [user]);

  //   useEffect(() => {
  //   const handleModulesUpdate = () => {
  //     const user = JSON.parse(window.localStorage.getItem("user") || "{}");
  //     console.log({user});
  //     setClinicModules({
  //       pharmacyModule: !!user.activeClinic?.pharmacyModule,
  //       pathologyModule: !!user.activeClinic?.pathologyModule,
  //       IPDModule: !!user.activeClinic?.IPDModule,
  //     });
  //   };
  //   window.addEventListener("modulesUpdated", handleModulesUpdate);
  //   handleModulesUpdate(); // initial load
  //   return () => window.removeEventListener("modulesUpdated", handleModulesUpdate);
  // }, []);

  //   useEffect(() => {
  //   const filtered = baseNavigation.filter((item) => {
  //     if (item.name === "Pharmacy" && !clinicModules.pharmacyModule) return false;
  //     if (item.name === "Laboratory" && !clinicModules.pathologyModule) return false;
  //     if (item.name === "Bed Management" && !clinicModules.IPDModule) return false;
  //     return true; 
  //   });
  //   console.log({filtered});
  //   setNavigation(filtered);
  // }, [clinicModules]);

  useEffect(() => {
    if (isVisibleUserOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisibleUserOptions]);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !(dropdownRef.current as any).contains(event.target)
    ) {
      setIsVisibleUserOptions(false);
    }
  };

  const handleDeveloperSettingClick = (item: navItem) => {
    if (item.children && item.children.length) {
      item.showChildren = !item.showChildren;
      setMobileMenuVisible(true);
    } else {
      setMobileMenuVisible(false);
    }
    setDeveloperSettings(item);
    navigate(item.route);
  };

  const updateNavigationState = (
    items: Array<navItem>,
    target: navItem,
    options: { toggleChildren?: boolean; setCurrent?: boolean }
  ): Array<navItem> => {
    return items.map((i) => {
      const hasChildren = i.children && i.children.length > 0;
      const isTarget = i.name === target.name;
      const updatedChildren = hasChildren
        ? updateNavigationState(i.children, target, options)
        : i.children;
      const childIsCurrent = updatedChildren?.some(
        (child) => child.isCurrent || child.showChildren
      );
      let showChildren: boolean;
      if (isTarget && hasChildren && options.toggleChildren) {
        showChildren = !i.showChildren;
      } else if (options.toggleChildren) {
        showChildren = false;
      } else {
        showChildren = childIsCurrent ? true : (i.showChildren || false);
      }
      const isCurrent = options.setCurrent
        ? isTarget && !hasChildren
        : i.isCurrent || false;
      return {
        ...i,
        children: updatedChildren,
        showChildren,
        isCurrent,
      };
    });
  };

  const handleNavigation = (item: navItem) => {
    const hasChildren = item.children && item.children.length > 0;
    if (!hasChildren) {
      setMobileMenuVisible(false);
    }
    setNavigation(updateNavigationState(navigation, item, { setCurrent: true }));
    if (item.route && item.route !== "#") {
      navigate(item.route);
    }
  };

  const handleToggleChildren = (item: navItem) => {
    setMobileMenuVisible(true);
    setNavigation(
      updateNavigationState(navigation, item, { toggleChildren: true })
    );
  };

  const handleMainMenuClick = (item: navItem) => {
    const hasChildren = item.children && item.children.length > 0;
    if (hasChildren) {
      handleToggleChildren(item);
    } else {
      handleNavigation(item);
    }
  };

  const handleLanguageChange = (value: string) => {
    updateUserData({ id: loggedInUser?.id, preferredLanguage: value }).then(
      (res: any) => {
        window.localStorage.setItem("user", JSON.stringify(res.data));
        const user = JSON.parse(window.localStorage.getItem("user") || "{}");
        setLoggedInUser(user);
        updateLanguage(user.preferredLanguage);
      }
    );
  };

  const signOut = () => {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("user");
    navigate("/login");
  };

  const onProfileClick = () => {
    navigate(`/profile/${loggedInUser?.id}`);
  };

  return (
    <>
      <div>
        {isMobileMenusVisible && (
          <div
            className="relative z-50 lg:hidden"
            role="dialog"
            aria-modal="true"
          >
            <div className="fixed inset-0 bg-gray-900/80"></div>

            <div className="flex fixed inset-0">
              <div className="flex relative flex-1 mr-16 w-full max-w-xs">
                <div className="flex absolute top-0 left-full justify-center pt-5 w-16">
                  <button
                    type="button"
                    className="-m-2.5 p-2.5"
                    onClick={() => setMobileMenuVisible(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <svg
                      className="w-6 h-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                {/* mobile screen */}
                <div className="flex overflow-y-auto flex-col gap-y-5 px-6 pb-4 bg-primary grow">
                  <div className="flex items-center h-16 shrink-0">
                    <img
                      className="w-auto h-14"
                      src={logo}
                      alt="Dhanvantaree"
                    />
                  </div>
                  <nav className="flex flex-col flex-1">
                    <ul className="flex flex-col flex-1 gap-y-7">
                      <li>
                        <ul className="-mx-2 space-y-1">
                          {navigation.map((i: any, index: any) => {
                            if (i.name === "layout_design") return null;
                            const hasChildren = i.children && i.children.length > 0;
                            const isLeafCurrent = !hasChildren && i.isCurrent;
                            return (
                              <li key={i.name} className="space-y-0">
                                <div
                                  className={classNames(
                                    "flex items-center justify-between gap-x-3 rounded-lg px-3 py-2.5 text-light text-sm cursor-pointer",
                                    isLeafCurrent
                                      ? "bg-active font-semibold"
                                      : "hover:bg-hover",
                                    "capitalize"
                                  )}
                                  onClick={() => handleMainMenuClick(i)}
                                >
                                  <div className="flex items-center gap-x-3 min-w-0">
                                    <i.icon className="w-5 h-5 shrink-0" />
                                    <span className="truncate">{t(i.name)}</span>
                                  </div>
                                  {hasChildren && (
                                    <ChevronDownIcon
                                      className={classNames(
                                        "w-5 h-5 shrink-0 transition-transform",
                                        i.showChildren && "rotate-180"
                                      )}
                                    />
                                  )}
                                </div>
                                {hasChildren && i.showChildren && (
                                  <ul className="pt-1 pb-1 ml-4 pl-3 border-l-2 border-white/30 space-y-0.5">
                                    {i.children.map((item: any) => {
                                      const itemHasChildren = item.children && item.children.length > 0;
                                      const isItemLeafCurrent = !itemHasChildren && item.isCurrent;
                                      return (
                                        <li key={item.name}>
                                          <div
                                            className={classNames(
                                              "flex items-center justify-between rounded-lg py-2 pr-2 pl-2 text-light text-sm cursor-pointer capitalize",
                                              isItemLeafCurrent
                                                ? "bg-active font-semibold"
                                                : "hover:bg-hover"
                                            )}
                                            onClick={() =>
                                              itemHasChildren
                                                ? handleToggleChildren(item)
                                                : handleNavigation(item)
                                            }
                                          >
                                            <span className="truncate">
                                              {t(item.name)}
                                            </span>
                                            {itemHasChildren && (
                                              <ChevronDownIcon
                                                className={classNames(
                                                  "w-4 h-4 shrink-0 transition-transform",
                                                  item.showChildren && "rotate-180"
                                                )}
                                              />
                                            )}
                                          </div>
                                          {itemHasChildren && item.showChildren && (
                                            <ul className="mt-0.5 ml-3 pl-2 border-l-2 border-white/20 space-y-0.5">
                                              {item.children.map((subItem: any) => (
                                                <li key={subItem.name}>
                                                  <span
                                                    onClick={() =>
                                                      handleNavigation(subItem)
                                                    }
                                                    className={classNames(
                                                      "block rounded-lg py-2 pl-2 text-light text-sm cursor-pointer capitalize",
                                                      subItem.isCurrent
                                                        ? "bg-active font-semibold"
                                                        : "hover:bg-hover"
                                                    )}
                                                  >
                                                    {t(subItem.name)}
                                                  </span>
                                                </li>
                                              ))}
                                            </ul>
                                          )}
                                        </li>
                                      );
                                    })}
                                  </ul>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
          <div className="flex overflow-y-auto flex-col gap-y-5 px-6 pb-4 bg-primary grow">
            <div className="flex items-center h-16 shrink-0">
              <img className="w-auto h-14" src={logo} alt="Dhanvantaree" />
            </div>
            <nav className="flex flex-col flex-1">
              <ul className="flex flex-col flex-1 gap-y-7">
                <li>
                  <ul className="-mx-2 space-y-1">
                    {navigation.map((i: any, index: any) => {
                      const hasChildren = i.children && i.children.length > 0;
                      const isLeafCurrent = !hasChildren && i.isCurrent;
                      return (
                        <li key={i.name} className="space-y-0">
                          <div
                            className={classNames(
                              "flex items-center justify-between gap-x-3 rounded-lg px-3 py-2.5 text-light text-sm cursor-pointer transition-colors",
                              isLeafCurrent
                                ? "bg-white/20 font-semibold"
                                : "hover:bg-white/10",
                              hasChildren && "capitalize"
                            )}
                            onClick={() => handleMainMenuClick(i)}
                          >
                            <div className="flex items-center gap-x-3 min-w-0">
                              <i.icon className="w-5 h-5 shrink-0" />
                              <span className="truncate capitalize">
                                {t(i.name)}
                              </span>
                            </div>
                            {hasChildren && (
                              <ChevronDownIcon
                                className={classNames(
                                  "w-5 h-5 shrink-0 transition-transform",
                                  i.showChildren && "rotate-180"
                                )}
                              />
                            )}
                          </div>
                          {hasChildren && i.showChildren && (
                            <ul className="mt-1 ml-4 pl-3 border-l-2 border-white/20 space-y-0.5">
                              {i.children.map((item: any) => {
                                const itemHasChildren = item.children && item.children.length > 0;
                                const isItemLeafCurrent = !itemHasChildren && item.isCurrent;
                                return (
                                  <li key={item.name}>
                                    <div
                                      className={classNames(
                                        "flex items-center justify-between rounded-lg py-2 pr-2 pl-2 text-light text-sm cursor-pointer transition-colors",
                                        isItemLeafCurrent
                                          ? "bg-white/20 font-semibold"
                                          : "hover:bg-white/10",
                                        "capitalize"
                                      )}
                                      onClick={() =>
                                        itemHasChildren
                                          ? handleToggleChildren(item)
                                          : handleNavigation(item)
                                      }
                                    >
                                      <span className="truncate">
                                        {t(item.name)}
                                      </span>
                                      {itemHasChildren && (
                                        <ChevronDownIcon
                                          className={classNames(
                                            "w-4 h-4 shrink-0 transition-transform",
                                            item.showChildren && "rotate-180"
                                          )}
                                        />
                                      )}
                                    </div>
                                    {itemHasChildren && item.showChildren && (
                                      <ul className="mt-0.5 ml-3 pl-2 border-l-2 border-white/15 space-y-0.5">
                                        {item.children.map((subItem: any) => (
                                          <li key={subItem.name}>
                                            <span
                                              onClick={() =>
                                                handleNavigation(subItem)
                                              }
                                              className={classNames(
                                                "block rounded-lg py-2 pl-2 text-light text-sm cursor-pointer transition-colors capitalize",
                                                subItem.isCurrent
                                                  ? "bg-white/20 font-semibold"
                                                  : "hover:bg-white/10"
                                              )}
                                            >
                                              {t(subItem.name)}
                                            </span>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </li>
                      );
                    })}
                    {loggedInUser.roles.find(
                      (i: any) => i.name === "developer"
                    ) && (
                        <li key="developer-settings" className="space-y-0">
                          <div
                            className={classNames(
                              "flex items-center justify-between gap-x-3 rounded-lg px-3 py-2.5 text-light text-sm cursor-pointer",
                              developerSettings.showChildren ? "bg-white/10" : "",
                              "hover:bg-white/10"
                            )}
                            onClick={() =>
                              handleDeveloperSettingClick(developerSettings)
                            }
                          >
                            <div className="flex items-center gap-x-3 min-w-0">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                className="w-5 h-5 shrink-0"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077 1.41-.513m14.095-5.13 1.41-.513M5.106 17.785l1.15-.964m11.49-9.642 1.149-.964M7.501 19.795l.75-1.3m7.5-12.99.75-1.3m-6.063 16.658.26-1.477m2.605-14.772.26-1.477m0 17.726-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205 12 12m6.894 5.785-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495"
                                />
                              </svg>
                              <span className="truncate">
                                {t(developerSettings.name)}
                              </span>
                            </div>
                            {developerSettings.children &&
                              developerSettings.children.length > 0 && (
                                <ChevronDownIcon
                                  className={classNames(
                                    "w-5 h-5 shrink-0 transition-transform",
                                    developerSettings.showChildren ? "rotate-180" : ""
                                  )}
                                />
                              )}
                          </div>
                          {developerSettings.children &&
                            developerSettings.showChildren && (
                              <ul className="mt-1 ml-4 pl-3 border-l-2 border-white/20 space-y-0.5">
                                {developerSettings.children.map((item: any) => (
                                  <li key={item.name}>
                                    <span
                                      onClick={() => handleNavigation(item)}
                                      className={classNames(
                                        "block rounded-lg py-2 pl-2 text-light text-sm cursor-pointer",
                                        item.isCurrent
                                          ? "bg-white/20 font-semibold"
                                          : "hover:bg-white/10"
                                      )}
                                    >
                                      {t(item.name)}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            )}
                        </li>
                      )}
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="lg:pl-72">
          <div className="flex sticky top-0 z-40 gap-x-4 items-center px-4 h-16 bg-white border-b border-gray-200 shadow-sm shrink-0 sm:gap-x-6 sm:px-6 lg:px-8">
            <button
              onClick={() => setMobileMenuVisible(true)}
              type="button"
              className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>

            {/* below is the stright line which is needed in mobile view */}
            <div
              className="w-px h-6 bg-gray-900/10 lg:hidden"
              aria-hidden="true"
            ></div>

            <div className="flex flex-1 gap-x-4 justify-end lg:self-stretch lg:gap-x-6">
              <div className="flex gap-x-4 items-center lg:gap-x-6">
                <Select
                  defaultValue="en"
                  style={{ width: 120 }}
                  onChange={handleLanguageChange}
                  value={loggedInUser.preferredLanguage}
                  options={[
                    { value: "en", label: "English" },
                    { value: "mr", label: "Marathi" },
                    { value: "hn", label: "Hindi" },
                  ]}
                />
                <button
                  type="button"
                  className="-m-2.5 p-2.5 text-gray-400 hover:text-gray-500"
                >
                  <span className="sr-only">View notifications</span>
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
                    />
                  </svg>
                </button>

                <div
                  className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-900/10"
                  aria-hidden="true"
                ></div>

                <div className="relative">
                  <button
                    type="button"
                    className="-m-1.5 flex items-center p-1.5"
                    id="user-menu-button"
                    aria-expanded="false"
                    aria-haspopup="true"
                    onClick={() =>
                      setIsVisibleUserOptions(!isVisibleUserOptions)
                    }
                  >
                    <span className="sr-only">Open user menu</span>
                    <div className="pt-1 w-8 h-8 uppercase bg-gray-200 rounded-full border border-gray-400">
                      {loggedInUser?.firstName.charAt(0) +
                        loggedInUser?.lastName.charAt(0)}
                    </div>
                  </button>
                  {isVisibleUserOptions && (
                    <div
                      className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="user-menu-button"
                      ref={dropdownRef}
                    >
                      <span
                        className="block px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer"
                        role="menuitem"
                        id="user-menu-item-0"
                        onClick={onProfileClick}
                      >
                        {t("your_profile")}
                      </span>
                      <span
                        onClick={signOut}
                        className="block px-3 py-1 text-sm leading-6 text-gray-900 cursor-pointer"
                        role="menuitem"
                        id="user-menu-item-1"
                      >
                        {t("sign_out")}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <main
            className={classNames(
              "bg-[#ECEFFF] h-[calc(100vh-65px)] overflow-x-hidden",
              location.pathname.startsWith("/ipd/visits/")
                ? "pt-0 px-4 pb-4"
                : "p-4"
            )}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
